<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Mantenimiento de Bienes</v-toolbar-title>

                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="2" md="2">
                                <v-text-field color="green darken-2" dense v-model="fecha" label="Fecha"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="8">
                                <v-select item-color="green" color="green darken-2" dense v-model="equipo"
                                    :items="listadoequipo" label="Equipo" item-text="nombre" item-value="codgral"
                                    @change="cargarManten()"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-radio-group v-model="tipo" row dense>
                                    <v-radio color="green darken-2" label="Mantenimiento de Emergencia"
                                        value="ME"></v-radio>
                                    <v-radio color="green darken-2" label="Mantenimiento Preventivo" value="MP"></v-radio>
                                    <v-radio color="green darken-2" label="Mantenimiento Correctivo" value="MC"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="8" md="8">
                                <v-select item-color="green" color="green darken-2" dense v-model="manten"
                                    :items="listadomanten" label="Tareas" item-text="tarea" return-object item-value="tarea"
                                    @change="completarmanten()"></v-select>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-text-field color="green darken-2" dense v-model="unidad" label="Unidad"></v-text-field>
                            </v-col>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field color="green darken-2" dense v-model="realizo"
                                        label="Realizó"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field color="green darken-2" dense v-model="precio"
                                        label="Costo Mantenimiento"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field color="green darken-2" dense v-model="km"
                                        label="Km de Uso"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                    <v-text-field color="green darken-2" dense v-model="horas"
                                        label="Hs de Uso"></v-text-field>
                                </v-col>

                            </v-row>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea color="green darken-2" auto-grow rows="6" label="Mantenimiento Efectuado" dense
                                    v-model="detalle"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <!-- <v-card>
                    <v-card-text>
                        <div>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <v-file-input color="green darken-2" show-size label="Seleccionar Archivo"
                                        v-model="archivo" @change="selectFiles"></v-file-input>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field color="green darken-2" v-model="titulo" prepend-icon="mdi-text"
                                        label="Título" maxlength="100" dense></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card> -->

                <v-card color="green lighten-4" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>

                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        fecha: moment().format("DD/MM/YYYY"),
        equipo: "",
        listadoequipo: [],
        codgral: "",
        codigo: "",
        unidad: "",
        manten: "",
        empresaselect: "",
        listadomanten: [],
        selectedIndex: '',
        realizo: "",
        precio: "",
        km: "",
        horas: "",
        detalle: "",
        tipo: "MP",
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
        selectedFiles: "",
        progressInfos: [],
        archivo: [],
        rulesarchivos: [
            (value) =>
                !value || value.size < 3000000 || "Las fotos deben pesar 3MB o menos",
        ],
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        selectedFiles: null,
        progressInfos: [],
        message: "",
        titulo: "",
        titulofoto: "",
        fileInfos: [],
        archivo: null,
    }),
    watch: {
        titulo(val) {
            if (this.titulo.length > 3 && this.tipo != null && this.tipo != "") {
                this.validsubir = true;
            } else {
                this.validsubir = false;
            }
        },


    },
    computed: {

        show: {
            get() {
                this.cargarEquipo();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarEquiposManten?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },
        cargarManten() {
            let self = this;
            self.listadomanten = [];
            axios
                .get("/SSGG/CargarMantenprev?", {
                    params: {
                        codgral: self.equipo
                    },
                })
                .then((response) => {
                    self.listadomanten = response.data;
                })
                .catch((error) => {
                    self.listadomanten = "";
                    console.log(error);
                });
        },

        completarmanten() {
            this.unidad = this.manten.unidad;

        },

        selectFiles(files) {
            this.selectedFiles = files;
        },
        vaciarModels() {
            this.equipo = "";
            this.manten = "";
            this.km = "";
            this.horas = "";
            this.precio = "";
            this.realizo = "";
            this.detalle = "";
            this.listadomanten = [];
            this.$router.push({ name: "MainSSGG" });
        },

        guardar() {
            this.$swal({
                title: "Guardar Mantenimiento",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        codgral: this.equipo,
                        fecha: this.fecha,
                        tipo: this.tipo,
                        detalle: this.detalle,
                        realizo: this.realizo,
                        precio: this.precio,
                        km: this.km,
                        horas: this.horas,
                        item: this.manten.item,
                    };

                    let self = this;
                    axios
                        .post("/SSGG/GuardarMantenimiento", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.vaciarModels();
                            self.showAlert({
                                icon: "success",
                                title: "Mantenimiento guardado con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                }
            });
        },



        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
